import { Typography, Form, Input, InputNumber, Select, Button, Space } from 'antd';

import { useAuth } from '../../hooks/useAuth';
import React, { useState, useEffect } from 'react';
import AddAssetService from '../../services/AddAssetService';
// import './AddAsset.css';
import SecurityService from '../../services/SecurityService';
import traderService from '../../services/TraderService';
import ShareFreezingService from '../../services/ShareFreezingService';

const { Title, Text } = Typography;

const ShareFreezing = () => {
  const [tradingAccountNo, setTradingAccountNo] = useState('');
  const [form] = Form.useForm();
  const { showNotification } = useAuth();
  const [requiredMark, setRequiredMarkType] = useState('');
  const [securities, setSecurities] = useState([]);
  const [loading, setLoading] = useState(false);

  const onFinish = async formValues => {
    const payload = {
      tradingAccountNo: formValues.tradingAccountNo,
      symbolCode: formValues.symbolCode,
      securityCode: formValues.securityCode,
      currentHolding: formValues.currentHolding,
      actionType: formValues.actionType,
      quantity: formValues.quantity,
    };
    setLoading(true);
    const result = await ShareFreezingService.performFreeze(payload);
    setLoading(false);
    console.log(result);

    if (result.success) {
      showNotification('success', 'Added');
    } else {
      showNotification('error', result.message);
    }
  };

  const symbolCode = securities.map(item => item.symbolCode).sort();

  const onRequiredTypeChange = ({ symbolCode, tradingAccountNo }) => {
    if (tradingAccountNo) setTradingAccountNo(tradingAccountNo);
    // setRequiredMarkType(requiredMarkValue);
    if (symbolCode) {
      let security = securities.find(security => security.symbolCode === symbolCode);
      form.setFieldsValue({
        securityCode: security.securityCode,
        currentHolding: security.currentHolding,
        // securityCode: security.securityCode,
      });
    }
  };

  //   useEffect(() => {
  //     const getSecurities = async () => {
  //       let response = await SecurityService.getSecurities();
  //       console.log(response);
  //       if (response.success) setSecurities(response.securityDataList);
  //       else showNotification('error', response.message);
  //     };
  //     getSecurities();
  //   }, []);

  const findTrader = async () => {
    console.log(tradingAccountNo);
    let response = await traderService.findTrader({
      tradingAccountNo: tradingAccountNo,
    });

    if (response.success) {
      form.setFieldsValue({
        tradingAccountId: response.traderId,
        traderName: response.name,
        traderNrc: response.nrcNo,
      });
      setSecurities(
        response.currentHoldingList.map(item => ({
          securityCode: item.securityCode.value,
          symbolCode: item.symbolCode.value,
          currentHolding: item.currentHolding,
        })),
      );
    } else showNotification('error', response.message);
  };

  return (
    <>
      <Title level={4} style={{ marginTop: 0, marginBottom: '2rem' }}>
        Share Freezing
      </Title>
      <Form
        className="addAsset-form"
        onFinish={onFinish}
        form={form}
        labelCol={{
          span: 8,
        }}
        onValuesChange={onRequiredTypeChange}
        requiredMark={requiredMark}
      >
        <Form.Item
          label="Trading Account No"
          name={'tradingAccountNo'}
          rules={[
            {
              required: true,
              message: 'Please do not leave blank',
            },
          ]}
        >
          {/* <Input/> */}
          <Space.Compact
            style={{
              width: '100%',
            }}
          >
            <Input size="middle" />
            <Button type="primary" onClick={findTrader}>
              Check
            </Button>
          </Space.Compact>
        </Form.Item>
        {/* <Form.Item label="Trading Account Id" name={'tradingAccountId'}>
          <Input disabled />
        </Form.Item> */}
        <Form.Item label="Trader Name" name={'traderName'}>
          <Input disabled />
        </Form.Item>
        <Form.Item label="NRC / Passport" name={'traderNrc'}>
          <Input disabled />
        </Form.Item>
        <Form.Item
          label="Symbol Code"
          name={'symbolCode'}
          rules={[
            {
              required: true,
              message: 'Please do not leave blank',
            },
          ]}
        >
          <Select size="middle">
            {symbolCode.map((item, index) => (
              <Select.Option key={index} value={item}>
                {item}
              </Select.Option>
            ))}
          </Select>
        </Form.Item>
        <Form.Item
          label="Security Code"
          name={'securityCode'}
          // rules={[
          //   {
          //     required: true,
          //     message: 'Please do not leave blank',
          //   },
          // ]}
        >
          <Input defaultValue={''} size="middle" disabled />
        </Form.Item>
        <Form.Item
          label="Current Holding"
          name={'currentHolding'}
          // rules={[
          //   {
          //     required: true,
          //     message: 'Please do not leave blank',
          //   },
          // ]}
        >
          <Input defaultValue={''} size="middle" disabled />
        </Form.Item>
        <Form.Item
          label="Action Type"
          name={'actionType'}
          rules={[
            {
              required: true,
              message: 'Please do not leave blank',
            },
          ]}
        >
          <Select size="middle">
            <Select.Option value="FREEZE">FREEZE</Select.Option>
            <Select.Option value="UNFREEZE">UNFREEZE</Select.Option>
          </Select>
        </Form.Item>
        <Form.Item
          label={'Quantity'}
          name={'quantity'}
          rules={[
            {
              required: true,
              message: 'Please do not leave blank',
            },
            ({ getFieldValue }) => ({
              validator(_, value) {
                if (!value || value <= getFieldValue('currentHolding')) {
                  return Promise.resolve();
                }
                return Promise.reject(
                  new Error('The quantity should not exceed the current holding!'),
                );
              },
            }),
          ]}
        >
          <InputNumber
            className="number-input"
            min={1}
            formatter={value => Number(value).toLocaleString('en-US')}
            parser={value => Number(value.toString().split(',').join(''))}
          />
        </Form.Item>

        <Form.Item>
          <Button
            type="primary"
            size="large"
            htmlType="submit"
            key={'submit'}
            style={{ float: 'right' }}
            loading={loading}
          >
            Perform
          </Button>
        </Form.Item>
      </Form>
    </>
  );
};

export default ShareFreezing;
